import React, {useEffect, useState, useContext} from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import $ from 'jquery';
import { Scrollbar } from 'react-scrollbars-custom';
import userlogo from "./../../../Public/img/avatar-14.jpg";
import { AuthContext } from "../../../context/AuthContext";
//import jQuery from 'jquery';
//import 'jquery-slimscroll';
//import SlimScroll from "react-jquery-slimscroll";



const Sidebar = () =>{

    const navigate = useNavigate();
    const currenturl = useLocation();

    const {user, setUser} = useContext(AuthContext);

    const [loggedname, setLoggedName] = useState("");
    const [loggedroleid, setLoggedRoleID] = useState(0);
    const [loggedemail, setLoggedEmail] = useState("");
    const [submenushow, setSubmenuShow] = useState(false);

    const scrollstyle = {
                        height: 'auto',
                        width: '100%',
                        position: 'right',
                        size: '7px',
                        color: '#ccc',
                        wheelStep: 10,
                        touchScrollStep: 100,
                        };

    useEffect(() =>{

        init();
		
        var $slimScrolls = $('.slimscroll');
        
        if($slimScrolls.length > 0) {
            
            var wHeight = $(window).height() - 60;
            $slimScrolls.height(wHeight);
            $('.sidebar .slimScrollDiv').height(wHeight);
            $(window).resize(function() {
                var rHeight = $(window).height() - 60;
                $slimScrolls.height(rHeight);
                $('.sidebar .slimScrollDiv').height(rHeight);
            });
        }
		

            $(document).on('mouseover', function(e) {
                e.stopPropagation();
                if ($('body').hasClass('mini-sidebar') && $('#toggle_btn').is(':visible')) {
                    var targ = $(e.target).closest('.sidebar, .header-left').length;
                    if (targ) {
                        $('body').addClass('expand-menu');
                        $('.subdrop + ul').slideDown();
                    } else {
                        $('body').removeClass('expand-menu');
                        $('.subdrop + ul').slideUp();
                    }
                    return false;
                }
            });

            if($('#btnFullscreen').length > 0) {
                document.getElementById('btnFullscreen').addEventListener('click', function() {
                    toggleFullscreen();
                });
            }
        //SlimScroll($);
        
        const userinfo = localStorage.getItem("userinfo");

        if(userinfo != "" && userinfo != null && userinfo != undefined)
        {
            const loggeduserdata = JSON.parse(userinfo);

            setLoggedName(loggeduserdata.name);
            setLoggedRoleID(loggeduserdata.role_id);
            setLoggedEmail(loggeduserdata.email);
            //console.log('User info===='+loggeduserdata);
            //console.log('User info===='+loggeduserdata.name);
        }

        console.log('curent url===' + currenturl);
        console.log('curent final url===' + currenturl.pathname);

        if(currenturl.pathname === '/admin/setting/state' || currenturl.pathname === '/admin/setting/city' || currenturl.pathname === '/admin/setting/dispositions' || currenturl.pathname === '/admin/setting/subdisposition' || currenturl.pathname === '/admin/setting/colleges')
        {
            setSubmenuShow(true);
        }
        else
        {
            setSubmenuShow(false);
        }

    }, []);

    const init = () =>{

		/*var Sidemenu = function() {
			this.$menuItem = $('.sidebar-menu a');
		};
		
		var $this = Sidemenu;
		$('.sidebar-menu a').on('click', function(e) {
			if($(this).parent().hasClass('submenu')) {
				e.preventDefault();
			}
			if(!$(this).hasClass('subdrop')) {
				$('ul', $(this).parents('ul:first')).slideUp(250);
				$('a', $(this).parents('ul:first')).removeClass('subdrop');
				$(this).next('ul').slideDown(350);
				$(this).addClass('subdrop');
			} else if($(this).hasClass('subdrop')) {
				$(this).removeClass('subdrop');
				$(this).next('ul').slideUp(350);
			}
		});
		$('.sidebar-menu ul li.submenu a.active').parents('li:last').children('a:first').addClass('active').trigger('click');*/
	}

	const toggleFullscreen = () =>{
		if (!document.fullscreenElement) 
		{
			document.documentElement.requestFullscreen();
		} 
		else 
		{
			if (document.exitFullscreen) 
			{
				document.exitFullscreen();
			}
		}
	}

    const handleSubMenu = () =>{
        //submenushow
        //setSubmenuShow
        setSubmenuShow(!submenushow);

    }

    const handleSignout = () =>{
        //localStorage.removeItem('cpmstoken');
        sessionStorage.removeItem('cpmstoken');
        localStorage.removeItem('userinfo');

        setUser(null);

        navigate('/sign-in', { replace: true });
    }

    return(
        <div className="sidebar" id="sidebar">
			
			<div className="sidebar-inner slimscroll">
                <Scrollbar style={scrollstyle}>
                    <div id="sidebar-menu" className="sidebar-menu">
                        <ul>
                            <li className="clinicdropdown">
                                <div className="profile-data">
                                    <img src={userlogo} className="img-fluid" alt="Profile" />
                                    <div className="user-names">
                                        <h5>{loggedname}</h5>
                                        {loggedroleid === 1 ?
                                            <h6>Super Admin</h6>
                                        :
                                            (loggedroleid === 2 ?
                                                <h6>Sales Manager</h6>
                                            :
                                                (loggedroleid === 3 ?
                                                    <h6>Caller</h6>
                                                :
                                                    (loggedroleid === 4 ?
                                                        <h6>Team Lead</h6>
                                                    :
                                                        <h6>{loggedemail}</h6>
                                                    )
                                                )
                                            )
                                        }
                                    </div>
                                </div>
                            </li>
                        </ul>
                        <ul>
                            <li>
                                <h6 className="submenu-hdr">Main Menu</h6>
                                <ul>
                                    <li>
                                        <Link to="/admin/dashboard" className={currenturl.pathname === '/admin/dashboard' ? 'active' : ''}>
                                            <i className="ti ti-home"></i>
                                            <span>Dashboard</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/admin/users" className={currenturl.pathname === '/admin/users' ? 'active' : ''}>
                                            <i className="ti ti-users"></i>
                                            <span>Users</span>
                                        </Link>
                                    </li>
                                    
                                    <li>
                                        <Link to="/admin/campaigns" className={currenturl.pathname === '/admin/campaigns' ? 'active' : ''}>
                                            <i className="ti ti-brand-campaignmonitor"></i>
                                            <span>Campaigns</span>
                                        </Link>
                                    </li>
                                    
                                    <li>
                                        <Link to="/admin/notifications" className={currenturl.pathname === '/admin/notifications' ? 'active' : ''}>
                                            <i className="ti ti-bell"></i>
                                            <span>Notifications</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/admin/upload-lead" className={currenturl.pathname === '/admin/upload-lead' ? 'active' : ''}>
                                            <i className="ti ti-upload"></i>
                                            <span>Upload Lead</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/admin/track-users" className={currenturl.pathname === '/admin/track-users' ? 'active' : ''}>
                                            <i className="ti ti-user-scan"></i>
                                            <span>Track Users</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/admin/activity-logs" className={currenturl.pathname === '/admin/activity-logs' ? 'active' : ''}>
                                            <i className="ti ti-activity"></i>
                                            <span>Activity Log</span>
                                        </Link>
                                    </li>

                                    <li>
                                        <ul>
                                            <li class="submenu">
                                                <Link to="#" onClick={handleSubMenu} className={ (currenturl.pathname === '/admin/setting/state' || currenturl.pathname === '/admin/setting/city' || currenturl.pathname === '/admin/setting/dispositions' || currenturl.pathname === '/admin/setting/subdisposition' || currenturl.pathname === '/admin/setting/colleges') ? (submenushow ? 'active subdrop' : 'subdrop') : (submenushow ? 'subdrop' : '') }>
                                                    <i class="ti ti-settings-cog"></i>
                                                    <span>Settings</span>
                                                    <span class="menu-arrow"></span>
                                                </Link>
                                                <ul className={ (currenturl.pathname === '/admin/setting/state' || currenturl.pathname === '/admin/setting/city' || currenturl.pathname === '/admin/setting/dispositions' || currenturl.pathname === '/admin/setting/subdisposition' || currenturl.pathname === '/admin/setting/colleges') ? (submenushow ? 'd-block' : 'd-none') : (submenushow ? 'd-block' : 'd-none')}>
                                                    <li>
                                                        <Link to="/admin/setting/state" className={currenturl.pathname === '/admin/setting/state' ? 'active' : ''}>
                                                            <span>State</span>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/admin/setting/city" className={currenturl.pathname === '/admin/setting/city' ? 'active' : ''}>
                                                            <span>City</span>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/admin/setting/dispositions" className={currenturl.pathname === '/admin/setting/dispositions' ? 'active' : ''}>
                                                            <span>Dispositions</span>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/admin/setting/subdisposition" className={currenturl.pathname === '/admin/setting/subdisposition' ? 'active' : ''}>
                                                            <span>Sub-Dispositions</span>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/admin/setting/colleges" className={currenturl.pathname === '/admin/setting/colleges' ? 'active' : ''}>
                                                            <span>Colleges</span>
                                                        </Link>
                                                    </li>
                                                    
                                                </ul>
                                            </li>
                                            {/*<li class="submenu">
                                                <Link to="#" onClick={handleSubMenu} className={submenushow ? ((currenturl.pathname === '/admin/setting/state' || currenturl.pathname === '/admin/setting/city' || currenturl.pathname === '/admin/setting/dispositions' || currenturl.pathname === '/admin/setting/subdisposition' || currenturl.pathname === '/admin/setting/colleges') ? 'actve subdrop' : 'subdrop') : ''}>
                                                    <i class="ti ti-settings-cog"></i>
                                                    <span>Settings</span>
                                                    <span class="menu-arrow"></span>
                                                </Link>
                                                <ul className={submenushow ? 'd-block' : 'd-none'}>
                                                    <li>
                                                        <Link to="/admin/setting/state" className={currenturl.pathname === '/admin/setting/state' ? 'active' : ''}>
                                                            <span>State</span>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/admin/setting/city" className={currenturl.pathname === '/admin/setting/city' ? 'active' : ''}>
                                                            <span>City</span>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/admin/setting/dispositions" className={currenturl.pathname === '/admin/setting/dispositions' ? 'active' : ''}>
                                                            <span>Dispositions</span>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/admin/setting/subdisposition" className={currenturl.pathname === '/admin/setting/subdisposition' ? 'active' : ''}>
                                                            <span>Sub-Dispositions</span>
                                                        </Link>
                                                    </li>
                                                    <li>
                                                        <Link to="/admin/setting/colleges" className={currenturl.pathname === '/admin/setting/colleges' ? 'active' : ''}>
                                                            <span>Colleges</span>
                                                        </Link>
                                                    </li>
                                                    
                                                </ul>
                                            </li>*/}
                                        </ul>
                                    </li>

                                    <li>
                                        <div onClick={handleSignout}>
                                            <i className="ti ti-power"></i>
                                            <span>Logout</span>
                                        </div>
                                    </li>
                                </ul>
                            </li>

                            

                            {/*<li>
                                <h6 className="submenu-hdr">Settings</h6>
                                <ul>
                                    <li>
                                        <Link to="/admin/setting/state">
                                            <i className="ti ti-user-up"></i>
                                            <span>State</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/admin/setting/city">
                                            <i className="ti ti-user-up"></i>
                                            <span>City</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/admin/setting/dispositions">
                                            <i className="ti ti-user-up"></i>
                                            <span>Dispositions</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/admin/setting/subdisposition">
                                            <i className="ti ti-user-up"></i>
                                            <span>Sub-Dispositions</span>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="/admin/setting/colleges">
                                            <i className="ti ti-user-up"></i>
                                            <span>Colleges</span>
                                        </Link>
                                    </li>
                                    
                                </ul>
                            </li>*/}

                            {/*<li>
                                <h6 className="submenu-hdr">Main Menu</h6>
                                <ul>
                                    <li className="submenu">
                                        <a href="javascript:void(0);" className="active subdrop">
                                            <i className="ti ti-layout-2"></i><span>Dashboard</span><span className="menu-arrow"></span>
                                        </a>
                                        <ul>
                                            <li><a href="index-2.html">Deals Dashboard</a></li>
                                            <li><a href="leads-dashboard.html" className="active">Leads Dashboard</a></li>
                                            <li><a href="project-dashboard.html">Project Dashboard</a></li>
                                        </ul>
                                    </li>
                                    <li className="submenu">
                                        <a href="javascript:void(0);"><i className="ti ti-brand-airtable"></i><span>Application</span><span className="menu-arrow"></span></a>
                                        <ul>
                                            <li><a href="chat.html">Chat</a></li>
                                            <li className="submenu submenu-two">
                                                <a href="javascript:void(0);">Call<span className="menu-arrow inside-submenu"></span></a>
                                                <ul>
                                                    <li><a href="video-call.html">Video Call</a></li>
                                                    <li><a href="audio-call.html">Audio Call</a></li>
                                                    <li><a href="call-history.html">Call History</a></li>
                                                </ul>
                                            </li>
                                            <li><a href="calendar.html">Calendar</a></li>
                                            <li><a href="email.html">Email</a></li>
                                            <li><a href="todo.html">To Do</a></li>
                                            <li><a href="notes.html">Notes</a></li>
                                            <li><a href="file-manager.html">File Manager</a></li>
                                            <li><a href="social-feed.html">Social Feed</a></li>
                                            <li><a href="kanban-view.html">Kanban</a></li>
                                            <li><a href="invoice.html">Invoices</a></li>
                                        </ul>
                                    </li>
                                    <li className="submenu">
                                        <a href="#">
                                            <i className="ti ti-user-star"></i><span>Super Admin</span>
                                            <span className="menu-arrow"></span>
                                        </a>
                                        <ul>
                                            <li><a href="dashboard.html">Dashboard</a></li>
                                            <li><a href="company.html">Companies</a></li>
                                            <li><a href="subscription.html">Subscriptions</a></li>
                                            <li><a href="packages.html">Packages</a></li>
                                            <li><a href="domain.html">Domain</a></li>
                                            <li><a href="purchase-transaction.html">Purchase Transaction</a></li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <h6 className="submenu-hdr">Layout</h6>
                                <ul>
                                    <li>
                                        <a href="layout-mini.html">
                                            <i className="ti ti-layout-navbar"></i><span>Mini</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="layout-horizontal-single.html">
                                            <i className="ti ti-layout-navbar-inactive"></i><span>Horizontal Single</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="layout-without-header.html">
                                            <i className="ti ti-layout-sidebar"></i><span>Without Header</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="layout-rtl.html">
                                            <i className="ti ti-text-direction-rtl"></i><span>RTL</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="layout-detached.html">
                                            <i className="ti ti-details"></i><span>Detached</span>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="layout-dark.html">
                                            <i className="ti ti-details"></i><span>Dark</span>
                                        </a>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <h6 className="submenu-hdr">CRM</h6>
                                <ul>
                                    <li>
                                        <a href="contacts.html"><i className="ti ti-user-up"></i><span>Contacts</span></a>
                                    </li>
                                    <li>
                                        <a href="companies.html"><i className="ti ti-building-community"></i><span>Companies</span></a>
                                    </li>
                                    <li>
                                        <a href="deals.html"><i className="ti ti-medal"></i><span>Deals</span></a>
                                    </li>
                                    <li>
                                        <a href="leads.html"><i className="ti ti-chart-arcs"></i><span>Leads</span></a>
                                    </li>
                                    <li>
                                        <a href="pipeline.html"><i className="ti ti-timeline-event-exclamation"></i><span>Pipeline</span></a>
                                    </li>
                                    <li>
                                        <a href="campaign.html"><i className="ti ti-brand-campaignmonitor"></i><span>Campaign</span></a>
                                    </li>
                                    <li>
                                        <a href="projects.html"><i className="ti ti-atom-2"></i><span>Projects</span></a>
                                    </li>
                                    <li>
                                        <a href="tasks.html"><i className="ti ti-list-check"></i><span>Tasks</span></a>
                                    </li>
                                    <li>
                                        <a href="proposals.html"><i className="ti ti-file-star"></i><span>Proposals</span></a>
                                    </li>
                                    <li>
                                        <a href="contracts.html"><i className="ti ti-file-check"></i><span>Contracts</span></a>
                                    </li>
                                    <li>
                                        <a href="estimations.html"><i className="ti ti-file-report"></i><span>Estimations</span></a>
                                    </li>
                                    <li>
                                        <a href="invoices.html"><i className="ti ti-file-invoice"></i><span>Invoices</span></a>
                                    </li>
                                    <li>
                                        <a href="payments.html"><i className="ti ti-report-money"></i><span>Payments</span></a>
                                    </li>
                                    <li>
                                        <a href="analytics.html"><i className="ti ti-chart-bar"></i><span>Analytics</span></a>
                                    </li>
                                    <li>
                                        <a href="activities.html"><i className="ti ti-bounce-right"></i><span>Activities</span></a>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <h6 className="submenu-hdr">Reports</h6>
                                <ul>
                                    <li className="submenu">
                                        <a href="javascript:void(0);">
                                            <i className="ti ti-file-invoice"></i><span>Reports</span><span className="menu-arrow"></span>
                                        </a>
                                        <ul>
                                            <li><a href="lead-reports.html">Lead Reports</a></li>
                                            <li><a href="deal-reports.html">Deal Reports</a></li>
                                            <li><a href="contact-reports.html">Contact Reports</a></li>
                                            <li><a href="company-reports.html">Company Reports</a></li>
                                            <li><a href="project-reports.html">Project Reports</a></li>
                                            <li><a href="task-reports.html">Task Reports</a></li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <h6 className="submenu-hdr">CRM Settings</h6>
                                <ul>
                                    <li><a href="sources.html"><i className="ti ti-artboard"></i><span>Sources</span></a></li>
                                    <li><a href="lost-reason.html"><i className="ti ti-message-exclamation"></i><span>Lost Reason</span></a></li>
                                    <li><a href="contact-stage.html"><i className="ti ti-steam"></i><span>Contact Stage</span></a></li>
                                    <li><a href="industry.html"><i className="ti ti-building-factory"></i><span>Industry</span></a></li>
                                    <li><a href="calls.html"><i className="ti ti-phone-check"></i><span>Calls</span></a></li>
                                </ul>
                            </li>
                            <li>
                                <h6 className="submenu-hdr">User Management</h6>
                                <ul>
                                    <li><a href="manage-users.html"><i className="ti ti-users"></i><span>Manage Users</span></a></li>
                                    <li><a href="roles-permissions.html"><i className="ti ti-navigation-cog"></i><span>Roles & Permissions</span></a></li>
                                    <li><a href="delete-request.html"><i className="ti ti-flag-question"></i><span>Delete Request</span></a></li>
                                </ul>
                            </li>
                            <li>
                                <h6 className="submenu-hdr">Membership</h6>
                                <ul>
                                    <li className="submenu">
                                        <a href="javascript:void(0);">
                                            <i className="ti ti-file-invoice"></i><span>Membership</span><span className="menu-arrow"></span>
                                        </a>
                                        <ul>
                                            <li><a href="membership-plans.html">Membership Plans</a></li>
                                            <li><a href="membership-addons.html">Membership Addons</a></li>
                                            <li><a href="membership-transactions.html">Transactions</a></li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <h6 className="submenu-hdr">Content</h6>
                                <ul>
                                    <li><a href="pages.html"><i className="ti ti-page-break"></i><span>Pages</span></a></li>
                                    <li className="submenu">
                                        <a href="javascript:void(0);">
                                            <i className="ti ti-map-pin-pin"></i><span>Location</span><span className="menu-arrow"></span>
                                        </a>
                                        <ul>
                                            <li><a href="countries.html">Countries</a></li>
                                            <li><a href="states.html">States</a></li>
                                            <li><a href="cities.html">Cities</a></li>
                                        </ul>
                                    </li>
                                    <li><a href="testimonials.html"><i className="ti ti-quote"></i><span>Testimonials</span></a></li>
                                    <li><a href="faq.html"><i className="ti ti-question-mark"></i><span>FAQ</span></a></li>
                                </ul>
                            </li>
                            <li>
                                <h6 className="submenu-hdr">Support</h6>
                                <ul>
                                    <li><a href="contact-messages.html"><i className="ti ti-page-break"></i><span>Contact Messages</span></a></li>
                                    <li><a href="tickets.html"><i className="ti ti-ticket"></i><span>Tickets</span></a></li>
                                </ul>
                            </li>
                            <li>
                                <h6 className="submenu-hdr">Settings</h6>
                                <ul>
                                    <li className="submenu">
                                        <a href="javascript:void(0);">
                                            <i className="ti ti-settings-cog"></i><span>General Settings</span><span className="menu-arrow"></span>
                                        </a>
                                        <ul>
                                            <li><a href="profile.html">Profile</a></li>
                                            <li><a href="security.html">Security</a></li>
                                            <li><a href="notifications.html">Notifications</a></li>
                                            <li><a href="connected-apps.html">Connected Apps</a></li>
                                        </ul>
                                    </li>
                                    <li className="submenu">
                                        <a href="javascript:void(0);">
                                            <i className="ti ti-world-cog"></i><span>Website Settings</span><span className="menu-arrow"></span>
                                        </a>
                                        <ul>
                                            <li><a href="company-settings.html">Company Settings</a></li>
                                            <li><a href="localization.html">Localization</a></li>
                                            <li><a href="prefixes.html">Prefixes</a></li>
                                            <li><a href="preference.html">Preference</a></li>
                                            <li><a href="appearance.html">Appearance</a></li>
                                            <li><a href="language.html">Language</a></li>
                                        </ul>
                                    </li>
                                    <li className="submenu">
                                        <a href="javascript:void(0);">
                                            <i className="ti ti-apps"></i><span>App Settings</span><span className="menu-arrow"></span>
                                        </a>
                                        <ul>
                                            <li><a href="invoice-settings.html">Invoice Settings</a></li>
                                            <li><a href="printers.html">Printers</a></li>
                                            <li><a href="custom-fields.html">Custom Fields</a></li>
                                        </ul>
                                    </li>
                                    <li className="submenu">
                                        <a href="javascript:void(0);">
                                            <i className="ti ti-device-laptop"></i><span>System Settings</span><span className="menu-arrow"></span>
                                        </a>
                                        <ul>
                                            <li><a href="email-settings.html">Email Settings</a></li>
                                            <li><a href="sms-gateways.html">SMS Gateways</a></li>
                                            <li><a href="gdpr-cookies.html">GDPR Cookies</a></li>
                                        </ul>
                                    </li>
                                    <li className="submenu">
                                        <a href="javascript:void(0);">
                                            <i className="ti ti-moneybag"></i><span>Financial Settings</span><span className="menu-arrow"></span>
                                        </a>
                                        <ul>
                                            <li><a href="payment-gateways.html">Payment Gateways</a></li>
                                            <li><a href="bank-accounts.html">Bank Accounts</a></li>
                                            <li><a href="tax-rates.html">Tax Rates</a></li>
                                            <li><a href="currencies.html">Currencies</a></li>
                                        </ul>
                                    </li>
                                    <li className="submenu">
                                        <a href="javascript:void(0);">
                                            <i className="ti ti-flag-cog"></i><span>Other Settings</span><span className="menu-arrow"></span>
                                        </a>
                                        <ul>
                                            <li><a href="storage.html">Storage</a></li>
                                            <li><a href="ban-ip-address.html">Ban IP Address</a></li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <h6 className="submenu-hdr">Pages</h6>
                                <ul>
                                    <li className="submenu">
                                        <a href="javascript:void(0);">
                                            <i className="ti ti-lock-square-rounded"></i><span>Authentication</span><span className="menu-arrow"></span>
                                        </a>
                                        <ul>
                                            <li><a href="login.html">Login</a></li>
                                            <li><a href="register.html">Register</a></li>
                                            <li><a href="forgot-password.html">Forgot Password</a></li>
                                            <li><a href="reset-password.html">Reset Password</a></li>
                                            <li><a href="email-verification.html">Email Verification</a></li>
                                            <li><a href="two-step-verification.html">2 Step Verification</a></li>
                                            <li><a href="lock-screen.html">Lock Screen</a></li>
                                        </ul>
                                    </li>
                                    <li className="submenu">
                                        <a href="javascript:void(0);">
                                            <i className="ti ti-error-404"></i><span>Error Pages</span><span className="menu-arrow"></span>
                                        </a>
                                        <ul>
                                            <li><a href="error-404.html">404 Error</a></li>
                                            <li><a href="error-500.html">500 Error</a></li>
                                        </ul>
                                    </li>
                                    <li><a href="blank-page.html"><i className="ti ti-apps"></i><span>Blank Page</span></a></li>
                                    <li><a href="coming-soon.html"><i className="ti ti-device-laptop"></i><span>Coming Soon</span></a></li>
                                    <li><a href="under-maintenance.html"><i className="ti ti-moneybag"></i><span>Under Maintenance</span></a></li>
                                </ul>
                            </li>
                            <li>
                                <h6 className="submenu-hdr">UI Interface</h6>
                                <ul>
                                    <li className="submenu">
                                        <a href="javascript:void(0);">
                                            <i className="ti ti-adjustments-check"></i><span>Base UI</span><span className="menu-arrow"></span>
                                        </a>
                                        <ul>
                                            <li><a href="ui-alerts.html">Alerts</a></li>
                                            <li><a href="ui-accordion.html">Accordion</a></li>
                                            <li><a href="ui-avatar.html">Avatar</a></li>
                                            <li><a href="ui-badges.html">Badges</a></li>
                                            <li><a href="ui-borders.html">Border</a></li>
                                            <li><a href="ui-buttons.html">Buttons</a></li>
                                            <li><a href="ui-buttons-group.html">Button Group</a></li>
                                            <li><a href="ui-breadcrumb.html">Breadcrumb</a></li>
                                            <li><a href="ui-cards.html">Card</a></li>
                                            <li><a href="ui-carousel.html">Carousel</a></li>
                                            <li><a href="ui-colors.html">Colors</a></li>
                                            <li><a href="ui-dropdowns.html">Dropdowns</a></li>
                                            <li><a href="ui-grid.html">Grid</a></li>
                                            <li><a href="ui-images.html">Images</a></li>
                                            <li><a href="ui-lightbox.html">Lightbox</a></li>
                                            <li><a href="ui-media.html">Media</a></li>
                                            <li><a href="ui-modals.html">Modals</a></li>
                                            <li><a href="ui-offcanvas.html">Offcanvas</a></li>
                                            <li><a href="ui-pagination.html">Pagination</a></li>
                                            <li><a href="ui-popovers.html">Popovers</a></li>
                                            <li><a href="ui-progress.html">Progress</a></li>
                                            <li><a href="ui-placeholders.html">Placeholders</a></li>
                                            <li><a href="ui-rangeslider.html">Range Slider</a></li>
                                            <li><a href="ui-spinner.html">Spinner</a></li>
                                            <li><a href="ui-sweetalerts.html">Sweet Alerts</a></li>
                                            <li><a href="ui-nav-tabs.html">Tabs</a></li>
                                            <li><a href="ui-toasts.html">Toasts</a></li>
                                            <li><a href="ui-tooltips.html">Tooltips</a></li>
                                            <li><a href="ui-typography.html">Typography</a></li>
                                            <li><a href="ui-video.html">Video</a></li>
                                            <li><a href="ui-sortable.html">Sortable</a></li>
                                            <li><a href="ui-swiperjs.html">Swiperjs</a></li>
                                        </ul>
                                    </li>
                                    <li className="submenu">
                                        <a href="javascript:void(0);">
                                            <i className="ti ti-box-align-bottom"></i><span>Advanced UI</span><span className="menu-arrow"></span>
                                        </a>
                                        <ul>
                                            <li><a href="ui-ribbon.html">Ribbon</a></li>
                                            <li><a href="ui-clipboard.html">Clipboard</a></li>
                                            <li><a href="ui-drag-drop.html">Drag & Drop</a></li>
                                            <li><a href="ui-rangeslider.html">Range Slider</a></li>
                                            <li><a href="ui-rating.html">Rating</a></li>
                                            <li><a href="ui-text-editor.html">Text Editor</a></li>
                                            <li><a href="ui-counter.html">Counter</a></li>
                                            <li><a href="ui-scrollbar.html">Scrollbar</a></li>
                                            <li><a href="ui-stickynote.html">Sticky Note</a></li>
                                            <li><a href="ui-timeline.html">Timeline</a></li>
                                        </ul>
                                    </li>
                                    <li className="submenu">
                                        <a href="javascript:void(0);"><i className="ti ti-chart-donut-2"></i>
                                            <span>Charts</span><span className="menu-arrow"></span>
                                        </a>
                                        <ul>
                                            <li><a href="chart-apex.html">Apex Charts</a></li>
                                            <li><a href="chart-c3.html">Chart C3</a></li>
                                            <li><a href="chart-js.html">Chart Js</a></li>
                                            <li><a href="chart-morris.html">Morris Charts</a></li>
                                            <li><a href="chart-flot.html">Flot Charts</a></li>
                                            <li><a href="chart-peity.html">Peity Charts</a></li>
                                        </ul>
                                    </li>
                                    <li className="submenu">
                                        <a href="javascript:void(0);"><i className="ti ti-icons"></i>
                                            <span>Icons</span><span className="menu-arrow"></span>
                                        </a>
                                        <ul>
                                            <li><a href="icon-fontawesome.html">Fontawesome Icons</a></li>
                                            <li><a href="icon-feather.html">Feather Icons</a></li>
                                            <li><a href="icon-ionic.html">Ionic Icons</a></li>
                                            <li><a href="icon-material.html">Material Icons</a></li>
                                            <li><a href="icon-pe7.html">Pe7 Icons</a></li>
                                            <li><a href="icon-simpleline.html">Simpleline Icons</a></li>
                                            <li><a href="icon-themify.html">Themify Icons</a></li>
                                            <li><a href="icon-weather.html">Weather Icons</a></li>
                                            <li><a href="icon-typicon.html">Typicon Icons</a></li>
                                            <li><a href="icon-flag.html">Flag Icons</a></li>
                                            <li><a href="icon-tabler.html">Tabler Icons</a></li>
                                            <li><a href="icon-bootstrap.html">Bootstrap Icons</a></li>
                                            <li><a href="icon-remix.html">Remix Icons</a></li>
                                        </ul>
                                    </li>
                                    <li className="submenu">
                                        <a href="javascript:void(0);">
                                            <i className="ti ti-forms"></i><span>Forms</span><span className="menu-arrow"></span>
                                        </a>
                                        <ul>
                                            <li className="submenu submenu-two">
                                                <a href="javascript:void(0);">Form Elements<span className="menu-arrow inside-submenu"></span></a>
                                                <ul>
                                                    <li><a href="form-basic-inputs.html">Basic Inputs</a></li>
                                                    <li><a href="form-checkbox-radios.html">Checkbox & Radios</a></li>
                                                    <li><a href="form-input-groups.html">Input Groups</a></li>
                                                    <li><a href="form-grid-gutters.html">Grid & Gutters</a></li>
                                                    <li><a href="form-select.html">Form Select</a></li>
                                                    <li><a href="form-mask.html">Input Masks</a></li>
                                                    <li><a href="form-fileupload.html">File Uploads</a></li>
                                                </ul>
                                            </li>
                                            <li className="submenu submenu-two">
                                                <a href="javascript:void(0);">Layouts<span className="menu-arrow inside-submenu"></span></a>
                                                <ul>
                                                    <li><a href="form-horizontal.html">Horizontal Form</a></li>
                                                    <li><a href="form-vertical.html">Vertical Form</a></li>
                                                    <li><a href="form-floating-labels.html">Floating Labels</a></li>
                                                </ul>
                                            </li>
                                            <li><a href="form-validation.html">Form Validation</a></li>
                                            <li><a href="form-select2.html">Select2</a></li>
                                            <li><a href="form-wizard.html">Form Wizard</a></li>
                                            <li><a href="form-pickers.html">Form Picker</a></li>
                                        </ul>
                                    </li>
                                    <li className="submenu">
                                        <a href="javascript:void(0);"><i className="ti ti-table"></i><span>Tables</span><span
                                                className="menu-arrow"></span></a>
                                        <ul>
                                            <li><a href="tables-basic.html">Basic Tables </a></li>
                                            <li><a href="data-tables.html">Data Table </a></li>
                                        </ul>
                                    </li>
                                    <li className="submenu">
                                        <a href="javascript:void(0);"><i className="ti ti-map"></i><span>Maps</span>
                                            <span className="menu-arrow"></span>
                                        </a>
                                        <ul>
                                            <li>
                                                <a href="maps-vector.html">Vector</a>
                                            </li>
                                            <li>
                                                <a href="maps-leaflet.html">Leaflet</a>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <h6 className="submenu-hdr">Help</h6>
                                <ul>
                                    <li><a href="javascript:void(0);"><i className="ti ti-file-type-doc"></i><span>Documentation</span></a></li>
                                    <li><a href="javascript:void(0);"><i className="ti ti-arrow-capsule"></i><span>Changelog v2.2.2</span></a></li>
                                    <li className="submenu">
                                        <a href="javascript:void(0);"><i className="ti ti-brand-databricks"></i><span>Multi Level</span><span className="menu-arrow"></span></a>
                                        <ul>
                                            <li><a href="javascript:void(0);">Level 1.1</a></li>
                                            <li className="submenu submenu-two"><a href="javascript:void(0);">Level 1.2<span className="menu-arrow inside-submenu"></span></a>
                                                <ul>
                                                    <li><a href="javascript:void(0);">Level 2.1</a></li>
                                                    <li className="submenu submenu-two submenu-three"><a href="javascript:void(0);">Level 2.2<span className="menu-arrow inside-submenu inside-submenu-two"></span></a>
                                                        <ul>
                                                            <li><a href="javascript:void(0);">Level 3.1</a></li>
                                                            <li><a href="javascript:void(0);">Level 3.2</a></li>
                                                        </ul>
                                                    </li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>*/}
                        </ul>
                    </div>
                </Scrollbar>
			</div>
            
            

            
            {/*<div className="slimScrollBar" style={{ background: 'rgb(204, 204, 204)', width: '7px', position: 'absolute', top: '0px', opacity: '0.4', display: 'none', borderRadius: '7px', zIndex: '99', right: '1px', height: '38.8652px'}}></div>
            <div className="slimScrollRail" style={{ width: '7px', height: '100%', position: 'absolute', top: '0px', display: 'none', borderRadius: '7px', background: 'rgb(51, 51, 51)', opacity: '0.2', zIndex: '90', right: '1px'}}></div>*/}
		</div>
    )
}

export default Sidebar;